import { Route } from "trader.ts/route";
import { Source } from "trader.ts/types/source";

export function makeClientsideRouter<Mode>(
  modeRoute: Route<{ mode: Mode }>,
  defaultMode: Mode,
): { start: () => Source<Mode>; makeHashLink: (m: Mode) => string } {
  function start() {
    const modeS: Source<Mode> = new Source(defaultMode);
    const parsed = modeRoute.parse(location.hash.substring(1));
    if (parsed !== null) {
      modeS.set(parsed.mode);
    }
    window.addEventListener("hashchange", function () {
      const parsed = modeRoute.parse(location.hash.substring(1));
      if (parsed === null) {
        console.log("Failed to parse hash");
        modeS.set(defaultMode);
      } else {
        modeS.set(parsed.mode);
      }
    });
    return modeS;
  }

  function makeHashLink(m: Mode): string {
    return modeRoute.mkClientSideLinkForHref({ mode: m });
  }

  return {
    start,
    makeHashLink,
  };
}
